'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Record, List, fromJS } from 'immutable';
import AdCreationWebsiteUrlRecord from './AdCreationWebsiteUrlRecord';
export const CreativeTypes = {
  PAID_SOCIAL: 'PAID_SOCIAL',
  EXPANDED_TEXT: 'EXPANDED_TEXT_AD',
  RESPONSIVE_TEXT: 'RESPONSIVE_SEARCH_AD'
};
export const DisallowedErrorContentReasons = {
  SYMBOLS: 'SYMBOLS',
  CAPITALIZATION: 'CAPITALIZATION',
  UNACCEPTABLE_SPACING: 'UNACCEPTABLE_SPACING',
  UNKNOWN: 'UNKNOWN'
};
export class AdCreationPaidSocialCreativeRecord extends Record({
  creativeType: CreativeTypes.PAID_SOCIAL,
  useExistingPost: false,
  selectedPost: null,
  headline: '',
  text: '',
  modified: false,
  media: null,
  mediaUploadStatus: null,
  leadSyncingEntityId: null,
  campaignId: null,
  cta: null,
  websiteUrl: new AdCreationWebsiteUrlRecord(),

  getCreativeText() {
    return {
      headline: this.headline,
      body: this.text,
      cta: this.cta
    };
  }

}) {
  constructor(_ref = {}) {
    let {
      websiteUrl
    } = _ref,
        opts = _objectWithoutPropertiesLoose(_ref, ["websiteUrl"]);

    super(Object.assign({}, opts, {
      selectedPost: opts.selectedPost && fromJS(opts.selectedPost),
      websiteUrl: new AdCreationWebsiteUrlRecord(websiteUrl)
    }));
  }

  isPopulated() {
    return !!this.headline || !!this.text;
  }

  getHeadline() {
    return this.headline;
  }

  getDescription() {
    return this.text;
  }

}
export class AdCreationExpandedTextCreativeRecord extends Record({
  creativeType: CreativeTypes.EXPANDED_TEXT,
  headline1: null,
  headline2: null,
  headline3: null,
  description1: null,
  description2: null,
  modified: false,
  websiteUrl: new AdCreationWebsiteUrlRecord(),

  getCreativeText() {
    return null;
  }

}) {
  constructor(_ref2 = {}) {
    let {
      websiteUrl
    } = _ref2,
        opts = _objectWithoutPropertiesLoose(_ref2, ["websiteUrl"]);

    super(Object.assign({}, opts, {
      websiteUrl: new AdCreationWebsiteUrlRecord(websiteUrl)
    }));
  }

  isPopulated() {
    return !!this.headline1 || !!this.description1 || !!this.headline2 || !!this.description2 || !!this.headline3;
  }

  getHeadline() {
    return [this.headline1, this.headline2, this.headline3].filter(Boolean).join(' | ');
  }

  getDescription() {
    return [this.description1, this.description2].filter(Boolean).join(' ');
  }

}
export class AdCreationResponsiveTextCreativeRecord extends Record({
  creativeType: CreativeTypes.RESPONSIVE_TEXT,
  headlines: null,
  descriptions: null,
  modified: false,
  websiteUrl: new AdCreationWebsiteUrlRecord(),

  getCreativeText() {
    return null;
  }

}) {
  constructor(_ref3 = {}) {
    let {
      websiteUrl,
      headlines = ['', '', ''],
      descriptions = ['', '']
    } = _ref3,
        opts = _objectWithoutPropertiesLoose(_ref3, ["websiteUrl", "headlines", "descriptions"]);

    super(Object.assign({}, opts, {
      headlines: List(headlines),
      descriptions: List(descriptions),
      websiteUrl: new AdCreationWebsiteUrlRecord(websiteUrl)
    }));
  }

  isPopulated() {
    return this.headlines && this.headlines.some(headline => !!headline) || this.descriptions && this.descriptions.some(desc => !!desc);
  }

  getHeadline() {
    return this.headlines.filter(Boolean).join(' | ');
  }

  getDescription() {
    return this.descriptions.filter(Boolean).join(' ');
  }

}
export const CREATIVE_RECORD_BY_TYPE = {
  [CreativeTypes.PAID_SOCIAL]: AdCreationPaidSocialCreativeRecord,
  [CreativeTypes.EXPANDED_TEXT]: AdCreationExpandedTextCreativeRecord,
  [CreativeTypes.RESPONSIVE_TEXT]: AdCreationResponsiveTextCreativeRecord
};